const tabMap = {
  rawData: 'mapInboundData',
  errorDetection: 'mapErrorData',
  dataExtraction: 'mapResourceData',
  code: 'mapAdditionalData',
  dataTypes: 'mapDataType'
};

const getResponseInput = (n, mapperId, mapperTab) => {
  const mappedId = tabMap[mapperTab];
  const tab = n?.find((m) => m?.mapperId === mapperId)?.data?.stepData?.find((s) => s?.id === mappedId);

  if (tab) {
    delete tab?.stepData;
    delete tab?.id;
    return tab;
  }

  const order = ['rawData', 'errorDetection', 'dataExtraction', 'code', 'dataTypes'];
  const index = mapperTab ? order.findIndex((m) => m === mapperTab) : 0;

  if (!Array.isArray(n)) {
    return n;
  }

  if (index === 0) {
    return n?.find((m) => m?.mapperId === 'raw')?.data;
  }

  return n?.find((m) => m?.mapperId === mapperId)?.data?.stepData?.[index - 1];
};

export default getResponseInput;
